import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminManagement } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const SearchSchema = z.object({
	tab: z.enum(["settings", "banners"]).optional(),
});

export const Route = createFileRoute("/st-admin/management/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => (
		<DashboardLayout>
			<STAdminManagement />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
